import React from 'react';
import { InnerNavMenu } from './InnerNavMenu';
import { Link } from "react-router-dom";
import schemes from '../../assets/images/schemes.jpg'
import pmfby from "../../assets/images/onboardlogo/pmfby.png";
import nhb from "../../assets/images/onboardlogo/NHB.png";
import shc from "../../assets/images/onboardlogo/shc.png";
import ami from "../../assets/images/onboardlogo/ami.png";
import nfsm from "../../assets/images/onboardlogo/nfsm.png";
import AIF from "../../assets/images/onboardlogo/AIF.png";
import Seed from "../../assets/images/onboardlogo/SeedsDistribution.png";
import acabc from "../../assets/images/onboardlogo/acabc.png";
import cluster from "../../assets/images/onboardlogo/cdp.png";
import nf from "../../assets/images/onboardlogo/nf.jpg";
import nbm from "../../assets/images/onboardlogo/nbm.jpg";
import pdmc from "../../assets/images/onboardlogo/pdmc.png";
import nbb from "../../assets/images/onboardlogo/nbb.jpg";
import mandt from "../../assets/images/onboardlogo/mandt.jpg";
import nmeo from "../../assets/images/onboardlogo/nmeo.jpg";
import cropic from "../../assets/images/onboardlogo/cropic2.jpg";
import fieldinspection from "../../assets/images/onboardlogo/fieldinspection.jpg";
import gces from "../../assets/images/onboardlogo/gces.jpg";
import agroforestry from "../../assets/images/onboardlogo/agroforestry.jpg";
import rad from "../../assets/images/onboardlogo/rad.jpg";

function Schemes() {
    return (
        <div>
            <InnerNavMenu />
            <div className="aboutus_Banner">
                <div className="container BreadcrumbContent">
                    <h1>Schemes</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">Schemes</li>
                        </ol>
                    </nav></div>
                <img src={schemes} className="img-fluid" alt='Our Schemes' />
            </div>
            <section className="mainSection">
                <div className="container">
                    {/* <div className="row g-5">

                        <div className="col-lg-5 col-md-7  fadeInUp" data--delay="0.3s">
                            <div>
                                <img src={incorporation} className="img-fluid" alt='KRISHI MAPPER- INCORPORATION OF INITIAL PROGRAM/SCHEMES' />


                            </div>

                        </div>
                        <div className="col-lg-7 col-md-12  fadeInUp" data--delay="0.5s" id="skipSchemes">
                            <div className="row g-5">
                                <div className="col-12 col-sm-6 col-lg-12 welcomeKrishiMapper">
                                    <h3 className="text-uppercase">Krishi MApper- Incorporation of Initial Program/Schemes
                                    </h3> <div className="bar"></div>
                                    <ul>
                                        <li><strong>CROPIC:</strong> An application under development by Digital Agriculture Division for PMFBY which facilitates surveyors of state and insurance companies to collect geotagged photographs and videos from the sowing to harvest of a crop based on phenological growth stages.
                                        </li><li><strong>Digital Crop Survey:</strong> An Application under development by Digital Agriculture Division as a part of reference application development to create a one single, verified source of truth for Farmer and Crop data in the state that can be utilized by multiple departments and other stakeholders in the eco-system (such as Banks, Insurance agencies etc)
                                        </li><li><strong>Natural Farming :</strong> An Application under development by Digital Agriculture Division for Natural Farming as a part of monitoring of natural farming activities and crop life cycle across state. The application includes polygon creation, collect geotagged photographs and monitor activities of natural farming by the Surveyors of State.
                                        </li>
                                    </ul>
                                </div>

                            </div>

                        </div>
                    </div> */}


<div className="row d-flex justify-content-center">
        <div className="col-md-12 onbordedSchemess">
        <h1>Schemes onboarded on Krishi MApper</h1>
                    <div className="bar"></div>
          <div className="row">
          <div className="col-md-2">
              <div className="card">
               
              <a href="https://www.nfsm.gov.in/" target="_blank">
              <div className="card-body">
              <img src={nfsm} alt='NFSM'/>
              </div>
                  <h6>National Food Security
Mission (NFSM)</h6>                 
              </a>
                
              </div>
            </div>
         
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://nhb.gov.in/Default.aspx?enc=3ZOO8K5CzcdC/Yq6HcdIxJhqz7e6GQcTK1J92dLzA2o=" target="_blank">
              <div className="card-body"><img src={nhb} alt='NHB Inspection'/>
              </div>
                  <h6>(NHB)<br/> Inspection</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://soilhealth.dac.gov.in/home" target="_blank">
              <div className="card-body"><img src={shc} alt='Soil Health Card'/>
              </div>
              <h6>Soil Health<br/> Card (SHC)</h6>
              </a>
               
              </div>
            </div>

            <div className="col-md-2">
              <div className="card">
             
              <a href="https://dmi.gov.in/" target="_blank">
              <div className="card-body"><img src={ami} Agri Marketing infrastructure/>
              </div>
              <h6>Agri. Marketing
Infrastructure (AMI)</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">               
              <a href="https://pmfby.gov.in/" target="_blank">
              <div className="card-body">
              <img src={pmfby} alt='PMFBY'/>
              </div>
                  <h6>PMFBY</h6>                 
              </a>                
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://agriinfra.dac.gov.in/" target="_blank">
              <div className="card-body"><img src={AIF} alt='AIF'/>
              </div>
                  <h6>AIF</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://seednet.gov.in/" target="_blank">
              <div className="card-body"><img src={Seed} alt='Seed Distributions'/>
              </div>
                  <h6>Seeds Distribution</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://www.agriclinics.net/" target="_blank">
              <div className="card-body"><img src={acabc} alt='ACABC'/>
              </div>
                  <h6>ACABC</h6>
              </a>
               
              </div>
            </div>
            {/* <div className="col-md-2">
              <div className="card">
             
              <a href="https://dcmsme.gov.in/CLCS_TUS_Scheme/Cluster-Development-Programme/Scheme_Guideline.aspx" target="_blank">
              <div className="card-body"><img src={cluster}/>
              </div>
                  <h6>Cluster Development Program (CDP)</h6>
              </a>
               
              </div>
            </div> */}
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://naturalfarming.dac.gov.in/" target="_blank">
              <div className="card-body"><img src={nf} alt='Natural Farming'/>
              </div>
                  <h6>Natural Farming (NF)</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://nbm.nic.in/" target="_blank">
              <div className="card-body"><img src={nbm} alt='National Bamboo Mission'/>
              </div>
                  <h6>National Bamboo Mission</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://pmksy.nic.in/" target="_blank">
              <div className="card-body"><img src={pdmc} alt='PDMC'/>
              </div>
                  <h6>PDMC</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://nbb.gov.in/" target="_blank">
              <div className="card-body"><img src={nbb} alt='National Beekeeping and Honey Mission'/>
              </div>
                  <h6>National Beekeeping
and Honey Mission
</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://agrimachinery.nic.in/" target="_blank">
              <div className="card-body">
                <img src={mandt} alt='M&T CHC Portal'/>
              </div>
                  <h6>M&T CHC Portal
</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://nmeo.dac.gov.in/" target="_blank">
              <div className="card-body"><img src={nmeo} alt='NMEO'/>
              </div>
                  <h6>NMEO
</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://pmfby.gov.in/" target="_blank">
              <div className="card-body"><img src={cropic} alt='Cropic'/>
              </div>
                  <h6>Cropic
</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a  target="_blank">
              <div className="card-body"><img src={fieldinspection} alt='Field Inspection'/>
              </div>
                  <h6>Field Inspection
</h6>
              </a>
               
              </div>
            </div>
            {/* <div className="col-md-2">
              <div className="card">
             
              <a href="https://gces.dac.gov.in/" target="_blank">
              <div className="card-body"><img src={gces} alt='GCES'/>
              </div>
                  <h6>GCES
</h6>
              </a>
               
              </div>
            </div> */}
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://agriwelfare.gov.in/Documents/Operational%20Guidelines%20of%20AGROFOREST%20Y%20under%20RKVY.pdf" target="_blank">
              <div className="card-body"><img src={agroforestry} alt='Agroforestry'/>
              </div>
                  <h6>Agroforestry
</h6>
              </a>
               
              </div>
            </div>
            <div className="col-md-2">
              <div className="card">
             
              <a href="https://nmsa.dac.gov.in/frmComponents.aspx" target="_blank">
              <div className="card-body"><img src={rad} alt='Rainfed Area
Development (RAD)'/>
              </div>
                  <h6>Rainfed Area
Development (RAD)
</h6>
              </a>
               
              </div>
            </div>
          </div>
        
        </div>
       
          </div>
                </div>
            </section>
            {/* <section className="whychoose">
                <div className="container">
                    <div className="card">
                        <div className="card-body">
                            <div className="row welcomeKrishiMapper">
                                <div className="col-md-7">
                                    <ul>
                                        <li><strong>NFSM:</strong> An Application will be developed by Digital Agriculture Division for CROP Division which covers NFSM crops which facilitates surveyors of state to collect geotagged photographs and videos from the sowing to harvest of a crop based on phenological growth stages. The application includes polygon creation, capturing geotagged photographs by the Surveyors of State.
                                        </li><li><strong>Seed Production:</strong> An Application will be developed by Digital Agriculture Division for Seed Division facilitates surveyors of state to collect geotagged photographs and videos. The application includes polygon creation, capturing geotagged photographs by the Surveyors of State.
                                        </li><li><strong>Crop Cutting Experiment:</strong> An Application will be developed by Digital Agriculture Division for MNCFC and State Agriculture department, various agencies to collect geotagged Crop Cutting Experiment data, photographs and various attributes related to CCE. The application includes predefine task allocation and monitoring of tasks.
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-5 sideMapping">
                                    <img src={sideMapping} className="img-fluid"  alt='KRISHI MAPPER- INCORPORATION OF INITIAL PROGRAM/SCHEMES'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <div className="container-fluid copyright py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 text-center  mb-3 mb-md-0">
                            Website Content Owned & Managed by Department of Agriculture & Farmers Welfare | MoA&FW | Government of India, India

                        </div>
                        <div className="col-md-12 col-sm-12 text-center">
                            Designed and Developed by DAD/IT, Ministry of Agriculture, New Delhi, India.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Schemes